import axios from 'axios';

const buildApi = () => {
  const raw = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/$/, '');
  const base = raw.replace(/\/api$/, '');
  return `${base}/api`;
};

export async function fetchWorkflowEnrollments({
  token,
  workflowId,
  agencyId,
  params = {},
}) {
  const api = buildApi();
  const response = await axios.get(`${api}/automations/workflows/${workflowId}/enrollments`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { agency_id: agencyId, ...params },
  });
  return response.data;
}

export async function fetchWorkflowExecutionLogs({
  token,
  workflowId,
  agencyId,
  params = {},
}) {
  const api = buildApi();
  const response = await axios.get(`${api}/automations/workflows/${workflowId}/execution-logs`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { agency_id: agencyId, ...params },
  });
  return response.data;
}

export async function fetchExecutionLogDetail({
  token,
  workflowId,
  logId,
  agencyId,
}) {
  const api = buildApi();
  const response = await axios.get(
    `${api}/automations/workflows/${workflowId}/execution-logs/${logId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      params: { agency_id: agencyId },
    },
  );
  return response.data;
}

export async function fetchExecutionPath({
  token,
  workflowId,
  executionId,
  agencyId,
}) {
  const api = buildApi();
  const response = await axios.get(
    `${api}/automations/workflows/${workflowId}/executions/${executionId}/path`,
    {
      headers: { Authorization: `Bearer ${token}` },
      params: { agency_id: agencyId },
    },
  );
  return response.data;
}

export const STATUS_PILL_CLASSES = {
  active: 'bg-blue-50 text-blue-700 border-blue-200',
  waiting: 'bg-amber-50 text-amber-700 border-amber-200',
  finished: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  executed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  failed: 'bg-red-50 text-red-700 border-red-200',
  skipped: 'bg-orange-50 text-orange-700 border-orange-200',
  removed: 'bg-slate-100 text-slate-600 border-slate-200',
};

export function formatWorkflowDate(value) {
  if (!value) return 'Not available';
  try {
    return new Date(value).toLocaleString(undefined, {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  } catch {
    return String(value);
  }
}
